import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import {
  NotificationType,
  type UserNotificationDto,
} from "Notifications/Api/notificationApi";

type ParsedParams = Record<string, string>;

function parseParams(notification: UserNotificationDto): ParsedParams {
  if (!notification.params) return {};
  try {
    return JSON.parse(notification.params) as ParsedParams;
  } catch {
    return {};
  }
}

export function resolveNotificationRoute(
  notification: UserNotificationDto,
): string | null {
  const params = parseParams(notification);

  switch (notification.type) {
    case NotificationType.SysAdmin_ActorWithdrawalRequested:
      if (params.withdrawalRequestID) {
        return AppRouting.WithdrawalApprovalDetail.path(
          params.withdrawalRequestID,
        );
      }
      return AppRouting.WithdrawalApprovals.path();

    case NotificationType.SysAdmin_PartnerRegistrationRequested:
    case NotificationType.SysAdmin_ActorRegistrationRequested:
      if (params.registrationRequestID) {
        return AppRouting.RegistrationRequestDetail.path(
          params.registrationRequestID,
        );
      }
      return AppRouting.RegistrationRequests.path();

    case NotificationType.Partner_JobApprovedByActor:
    case NotificationType.Partner_JobRejectedByActor:
      if (params.projectID && params.jobID) {
        return AppRouting.ProjectJobDetail.path(params.projectID, params.jobID);
      }
      return null;

    default:
      return null;
  }
}
